// extracted by mini-css-extract-plugin
module.exports = {"pane":"SingleImage-pane-fee2","back":"SingleImage-back-fee2","image":"SingleImage-image-fee2"};